import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessagesByPkQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type MessagesByPkQuery = { __typename?: 'query_root', messages_by_pk?: { __typename?: 'messages', id: any, body?: string | null, createdAt: any, senderId?: string | null, user?: { __typename?: 'users', firstName: string, lastName: string, profilePhotoLink?: string | null } | null, attachments: Array<{ __typename?: 'messageAttachments', attachementLink: string, attachmentType: string }>, evidenceAttachment: Array<{ __typename?: 'messageAttachments', attachementLink: string, attachmentType: string }>, messageThreads: Array<{ __typename?: 'messages', id: any, body?: string | null, createdAt: any, senderId?: string | null, user?: { __typename?: 'users', firstName: string, lastName: string, profilePhotoLink?: string | null } | null, attachments: Array<{ __typename?: 'messageAttachments', attachementLink: string, attachmentType: string }>, evidenceAttachment: Array<{ __typename?: 'messageAttachments', attachementLink: string, attachmentType: string }> }> } | null };


export const MessagesByPkDocument = gql`
    query messagesByPk($id: uuid!) {
  messages_by_pk(id: $id) {
    id
    body
    createdAt
    senderId
    user {
      firstName
      lastName
      profilePhotoLink
    }
    attachments(where: {attachmentType: {_in: ["video", "image", "audio"]}}) {
      attachementLink
      attachmentType
    }
    evidenceAttachment: attachments(where: {attachmentType: {_eq: "url"}}) {
      attachementLink
      attachmentType
    }
    messageThreads(order_by: {createdAt: asc}, where: {status: {_eq: "published"}}) {
      id
      body
      createdAt
      senderId
      user {
        firstName
        lastName
        profilePhotoLink
      }
      attachments(where: {attachmentType: {_in: ["video", "image", "audio"]}}) {
        attachementLink
        attachmentType
      }
      evidenceAttachment: attachments(where: {attachmentType: {_eq: "url"}}) {
        attachementLink
        attachmentType
      }
    }
  }
}
    `;

/**
 * __useMessagesByPkQuery__
 *
 * To run a query within a React component, call `useMessagesByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessagesByPkQuery(baseOptions: Apollo.QueryHookOptions<MessagesByPkQuery, MessagesByPkQueryVariables> & ({ variables: MessagesByPkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByPkQuery, MessagesByPkQueryVariables>(MessagesByPkDocument, options);
      }
export function useMessagesByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByPkQuery, MessagesByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByPkQuery, MessagesByPkQueryVariables>(MessagesByPkDocument, options);
        }
export function useMessagesByPkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessagesByPkQuery, MessagesByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagesByPkQuery, MessagesByPkQueryVariables>(MessagesByPkDocument, options);
        }
export type MessagesByPkQueryHookResult = ReturnType<typeof useMessagesByPkQuery>;
export type MessagesByPkLazyQueryHookResult = ReturnType<typeof useMessagesByPkLazyQuery>;
export type MessagesByPkSuspenseQueryHookResult = ReturnType<typeof useMessagesByPkSuspenseQuery>;
export type MessagesByPkQueryResult = Apollo.QueryResult<MessagesByPkQuery, MessagesByPkQueryVariables>;